import React from 'react'

import Carousel from './carousel2'

var INTERVAL = 3000

var TEXTS = [
  {
    eia: {
      name: 'Esma Isis-Arnautovic',
      text:
        'Der Mensch lebt in einem Spannungsfeld zwischen seiner Vergangenheit, seiner Gegenwart und seiner Zukunft. Lasst uns diesen Trialog fruchtbar machen und gesellschaftlich nutzen, indem wir die Vergangenheit verarbeiten, die Gegenwart reflektieren und die Zukunft gemeinsam gestalten.'
    }
  },
  {
    hff: {
      name: 'Hermann Fränkert-Fechter',
      text:
        'Das Bonifatiuswerk möchte dazu beitragen, dass Menschen die versöhnende und verbindende Kraft des Glaubens erfahren, gerade dort, wo Verletzungen eine gute Nachbarschaft der Religionen unmöglich erscheinen lässt.'
    }
  },
  {
    hm: {
      name: 'Hooria Mashhour',
      text:
        'Ich halte es mit der libyschen Dichterin Rodina Alfelali, als sie gefragt wurde, ob sie Christin oder Muslimin sei. Sie antwortete: *Es macht keinen Unterschied, ich bete zu Gott und zwar mit den Anhängern aller monotheistischen -  auf Offenbarung vertrauenden -  Religionen*\nفسألني أي ديانة أتبع الإسلام أم المسيحية فأجبته بأني أعبد ربي بكل الأديان السماوية - ردينة الفيلالي'
    }
  },
  {
    pjp: {
      name: 'Jens Petzold',
      text:
        '*Freiheit ist immer Freiheit der Andersdenkenden*\n(Rosa Luxemburg)'
    }
  },
  {
    mg: {
      name: 'Margareta Gruber',
      text:
        '*Gelobt seist du, mein Herr, durch jene, die verzeihen um deiner Liebe willen…*\nIm Sonnengesang des Heiligen Franziskus von Assisi preisen alle Geschöpfe Gott durch das, wodurch sie ihrem Schöpfer ähnlich sind. Beim Menschen ist dies die Kraft zur Vergebung.'
    }
  },
  {
    mvm: {
      name: 'Marie von Manteuffel',
      text:
        'Es ist unsere Aufgabe, angesichts der vielfältigen Notsituationen nicht in emphatische Schockstarre zu verfallen, sondern unermüdlich Brücken zu und zwischen den Menschen zu bauen. Dabei müssen wir es den Betroffenen überlassen, ob sie über diese Brücken gehen wollen und es aushalten, wenn unser gut gemeintes Engagement nicht immer vollständig in unserem Sinne greift.'
    }
  },
  {
    mk: {
      name: 'Milad Karimi',
      text: 'Wer glaubt, ist ein Flüchtling.'
    }
  },
  {
    kh: {
      name: 'Klaudia Höfig',
      text:
        '"Jenseits von richtig und falsch ist ein Raum. Dort werde ich dich treffen."\n(Mevlana Rumi)'
    }
  },
  {
    ts: {
      name: 'Tobias Specker',
      text:
        '*Vom Christentum habe ich gelernt, dass man niemals nur die eigenen Toten zählen darf.*\n(Navid Kermani)'
    }
  }
]

export default function Citation() {
  return (
    <section id="citation" className={'citation'}>
      <Carousel
        slides={TEXTS}
        interval={INTERVAL}
        className="citation"
        index={6}
      />
    </section>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/citation.js
 **/